import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LayoutUtilsService } from 'src/app/core/_base/crud';
import { AuthAdminService } from 'src/app/core/auth/service/auth-admin.service';
import { AdminUserService } from 'src/app/core/user/admin-user.service';
import { BaseFormComponent } from 'src/app/shared/crud/base-form.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent
  extends BaseFormComponent
  implements OnInit, OnDestroy
{
  loading = false;
  isLoggedIn$: Observable<boolean>;
  errors: any = [];

  private returnUrl: any;

  constructor(
    protected authService: AuthAdminService,
    protected router: Router,
    protected layoutUtilsService: LayoutUtilsService,
    protected fb: FormBuilder,
    protected cdr: ChangeDetectorRef,
    protected route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    this.handleCompanyKey();
    super.initForm();

    this.route.queryParams.subscribe((params) => {
      this.returnUrl = params['returnUrl'] || '/';
    });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
    this.loading = false;
  }

  createForm() {
    this.form = this.fb.group({
      email: [
        '',
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.minLength(3),
        ]),
      ],
      password: [
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(7),
          Validators.maxLength(100),
        ]),
      ],
    });
  }

  submit() {
    if (!this.validateForm()) {
      this.cdr.detectChanges();
      return;
    }

    this.loadingSubject.next(true);
    const login = this.form.getRawValue() as any;

    this.subscriptions.push(
      this.authService
        .authenticate(login, this.route.parent?.snapshot.params.companyToken)
        .pipe(
          finalize(() => {
            this.loadingSubject.next(false);
            this.cdr.markForCheck();
          })
        )
        .subscribe(
          () => {
            this.router.navigate([
              '/' +
                this.route.parent?.snapshot.params.companyToken +
                '/dashboard',
            ]);
          },
          (err) => {
            this.form.reset();
            this.submitError(err);
          }
        )
    );
  }
}
